/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  
  /**
   * Модель для ответов на товары в претензии
   */
  app.ClaimItemResponse = app.Model.extend({
    set: function (attributes) {
      var comments = this.get('claim_item_response_comments');
      if (_.isObject(attributes) && attributes.hasOwnProperty('claim_item_response_comments')) {
        if (!(comments instanceof app.Collection)) {
          comments = new app.Collection();
        }
        comments.reset(_.toArray(attributes.claim_item_response_comments));
        attributes.claim_item_response_comments = comments;
      }
      return app.Model.prototype.set.apply(this, arguments);
    }
  });
})();


}.call(window));